<template>
    <div>
        <div class="Sys-warp" style="min-height: 800px">
            <el-breadcrumb class="bread_crumb" separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>联系我们</el-breadcrumb-item>
            </el-breadcrumb>


            <div>
                <div style="text-align: center;"><h2>联系我们</h2></div>
                <el-divider></el-divider>
                <div><p style="line-height:32.25pt; margin:0pt"><span
                        style="font-family:微软雅黑; font-size:14pt; font-style:normal; font-weight:bold; text-decoration:none; text-transform:none">四川省社会保险干部培训中心</span>
                </p>
                    <p style="line-height:32.25pt; margin:0pt">
                        <span
                            style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">电话：</span>

                        <span
                                style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">028-86696526  </span>
                        <br><span style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">         电子邮箱：ssbqxzx@163.com</span>
                    </p>
                    <p style="line-height:32.25pt; margin:0pt"><span
                            style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">网络</span><span
                            style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">地址：</span><span
                            style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">四川社</span><span
                            style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">保培训.com</span>
                    </p>
                    <br>
                    <p style="font-size:12pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
                        <span style="font-family:微软雅黑; font-size:12pt; font-style:normal; text-decoration:none; text-transform:none">通讯地址：成都市青羊区西月城街20号</span>
                    </p>
                    </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        data() {
            return {
                articleId: this.$route.params.id,
                categoryName: "",
                categoryIndex: 0,
                courseList: [],
            }
        },
        methods: {
            fetch: function () {

            },
            timeFormat(time) {
                if (time > -1) {
                    var hour = Math.floor(time / 3600);
                    var min = Math.floor(time / 60) % 60;
                    var sec = time % 60;
                    if (hour < 10) {
                        time = '0' + hour + ":";
                    } else {
                        time = hour + ":";
                    }

                    if (min < 10) {
                        time += "0";
                    }
                    time += min + ":";

                    if (sec < 10) {
                        time += "0";
                    }
                    time += sec;
                }
                return time;
            },
        },
        mounted() {

        },
        created() {
            window, scrollTo(0, 0);
        },
    }
</script>
<style scoped>
    .bread_crumb {
        margin-top: 24px;
        font-size: 16px;
        font-weight: 400;
    }

    .tab_bar {
        margin-top: 25px;
        margin-bottom: 25px;
        font-size: 16px;
        font-weight: 400;
    }

    .tab_bar_item_selected {
        color: #0775E5;
        font-weight: bold;
    }

    .article_content {
        font-size: 18px;
        line-height: 28px;

    }

    .article_img {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>
